import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Widgets from '../components/WidgetTiles';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <>
      <Helmet>
        <title>About Us | Redemption Psychiatry</title>
      </Helmet>
      <div className="wrap">
        <Header />
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div id="content" role="main" className="home">

            {/* Interior Header */}
            <div id="interior-header-container" className="container-fluid">
              <div className="container">
                <h1>About Us</h1>
              </div>
            </div>

            {/* Submenu */}
            <div id="interior-sub-menu-container" className="container-fluid">
              <div className="container">
                <div className="submenu-wrapper">
                  <ul className="submenu-list">
                    <li><a href="#about-us">About Us</a></li>
                    <li><a href="#our-story">Our Story</a></li>
                    <li><a href="#going-green">Going Green</a></li>
                    <li><a href="#mission-vision">Our Mission & Vision</a></li>
                    <li><a href="#our-partners">Our Partners</a></li>
                    <li><a href="/provider-biographies">Our Team</a></li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Section 1: Hope. Healing. Innovation. */}
            <div id="about-us" className="container text-center my-5">
              <h2>Hope. Healing. Innovation.</h2>
              <p>At Redemption Psychiatry, we believe that mental health care should be as unique as the individuals we serve. As a physician-owned practice, we are committed to providing compassionate, patient-first care, combining human connection with the latest advancements in psychiatry to deliver real, lasting results.</p>
            </div>

            {/* Section 2: Our Story */}
            <div id="our-story" className="container-fluid">
              <div className="container" id="our-story-container">
                <img
                  src="/img/dr-friday.png"
                  alt="Doctor Jason Friday"
                  className="float-image"
                />
                <div className="our-story-text">
                  <h3>Our Story</h3>
                  <p>
                    Redemption Psychiatry is an outpatient psychiatric group that was founded by Doctor Jason Friday to provide quality mental
                    health treatment to children, adolescents, and adults across the Valley. Specializing in a wide range of psychiatric disorders and
                    patient populations, we've recognized the overwhelming need for psychiatric care and are proud to meet it. Redemption
                    Psychiatry is committed to accessible care, and believes that you should be able to access treatment no matter who you are,
                    where you live, or what you do. For this reason we offer our treatments at rates vastly below typical cost and offer a variety of
                    discounts and sliding scales to ensure everyone has an opportunity to receive the most skilled and compassionate care available
                  </p>
                </div>

                <p>
                  Revolution Treatments is an advanced treatment team that works with Redemption Psychiatry. If you are seeking a new patient
                  intake, please click the link below. You will be scheduled with a provider who will review your medication history and discuss
                  ketamine, tms, and other treatment options with you, helping you to get the most effective and informed care possible.
                </p>
              </div>
            </div>

            {/* Mission and Vision */}
            <div id="mission-vision" className="container my-5">
              <div className="row g-4">

                {/* Our Mission Card */}
                <div className="col-12 col-md-12">
                  <div className="p-5 rounded shadow" style={{ backgroundColor: '#ffffff', textAlign: 'center' }}>
                    <h4><strong>Our Mission</strong></h4>
                    <p>
                      To provide the highest quality psychiatric care using the most advanced, evidence-based treatments available.
                      <span style={{ fontSize: '0.9em', fontStyle: 'italic' }}>
                        {' '}We employ the newest medical technology for treatments and to provide our clients with the information and convenience expected in our fast-paced modern lives.
                        This allows us to spend more appointment time relating to our clients instead of collecting and documenting routine information.
                      </span>
                    </p>
                  </div>
                </div>

                {/* Our Vision Card */}
                <div className="col-12 col-md-12">
                  <div className="p-5 rounded shadow" style={{ backgroundColor: '#ffffff', textAlign: 'center' }}>
                    <h4><strong>Our Vision</strong></h4>
                    <p>
                      To redeem the practice of Psychiatry for providers and patients, remove any stigma towards mental illness, and stay at the forefront of advancements in Psychiatric treatment.
                      <span style={{ fontSize: '0.9em', fontStyle: 'italic' }}>
                        {' '}At Redemption we believe there is strength in seeking help.
                        All too often the stigma associated with mental illness prevents those who need care from seeking it.
                        We are doing our best to combat this attitude and assure our neighbors and friends that seeking and receiving mental health care is neither shameful nor weak.
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Decorative Divider */}
            <div
              style={{
                width: '50%',
                height: '5px',
                backgroundColor: '#2D4F91',
                margin: '40px auto'
              }}
            ></div>
            {/* Section 3: Going Green */}
            <div id="going-green" className="container text-center my-4">
              <h4>Going Green</h4>
              <p>Redemption Psychiatry is a paperless company. This means that with the exception of special paperwork we avoid printed materials, and instead focus on digital means of care including eCheckIns, patient portals, and minimal fax use and storage. We've streamlined our intake process and appointment system to reduce waste and allow us to spend more of our limited appointment time with our clients instead of collecting and documenting routine information.</p>
              <p>Very different than other offices, you will also experience the convenience of having prescriptions sent directly to the pharmacy, receiving automated text message appointment reminders, filling out forms, checking appointments, signing documents, and receiving educational resources online.</p>
            </div>

            {/* Decorative Divider */}
            <div
              style={{
                width: '50%',
                height: '5px',
                backgroundColor: '#2D4F91',
                margin: '40px auto'
              }}
            ></div>

            {/* Meet the Team Section */}
            <div className="container text-center my-5">
              <h3>Meet Our Team</h3>
              <p>Get to know the dedicated professionals who make up our compassionate team at Redemption Psychiatry.</p>
              <a href="/provider-biographies" className="btn btn-primary btn-lg button blue" style={{ backgroundColor: '#2D4F91', borderColor: '#2D4F91' }}>
                Meet the Team
              </a>
            </div>

            {/* Decorative Divider */}
            <div
              style={{
                width: '50%',
                height: '5px',
                backgroundColor: '#2D4F91',
                margin: '40px auto'
              }}
            ></div>

            {/* Our Partners */}
            <div id="our-partners" className="container text-center my-5">
              <h3>Our Partners</h3>
              <p>Check out our partners, and click the logo to visit their website!</p>

              <div className="partner-logos-container mt-4">
                {/* First Row */}
                <div className="row g-4 mb-4 justify-content-center">
                  <div className="col-6 col-md-3 partner-logo">
                    <a href="https://gilbertcounselors.com/" target="_blank" rel="noopener noreferrer">
                      <img
                        src="/img/partners/brand-01.jpg"
                        alt="Gilbert Counselors"
                        className="img-fluid partner-image"
                      />
                    </a>
                  </div>
                  <div className="col-6 col-md-3 partner-logo">
                    <a href="https://www.sarvacenter.com/" target="_blank" rel="noopener noreferrer">
                      <img
                        src="/img/partners/brand-04.png"
                        alt="Sarva Center"
                        className="img-fluid partner-image"
                      />
                    </a>
                  </div>
                  <div className="col-6 col-md-3 partner-logo">
                    <a href="https://www.totallifeaz.com/" target="_blank" rel="noopener noreferrer">
                      <img
                        src="https://images.squarespace-cdn.com/content/v1/5f60401cea4962423a1df95e/1600204151813-XW7K9PFNDS3XF2LAC8M8/total-life-counseling-az-logo.png?format=1500w"
                        alt="Total Life Counseling"
                        className="img-fluid partner-image"
                      />
                    </a>
                  </div>
                  <div className="col-6 col-md-3 partner-logo">
                    <a href="https://www.asapaz.com/?utm_source=gmb-mesa" target="_blank" rel="noopener noreferrer">
                      <img
                        src="/img/partners/brand-07.webp"
                        alt="ASAPAZ"
                        className="img-fluid partner-image"
                      />
                    </a>
                  </div>
                </div>

                {/* Second Row */}
                <div className="row g-4 mb-4 justify-content-center">
                  <div className="col-6 col-md-3 partner-logo">
                    <a href="https://alohacounseling.org/" target="_blank" rel="noopener noreferrer">
                      <img
                        src="https://alohacounseling.org/wp-content/uploads/2021/10/Logo-2.png"
                        alt="Aloha Counseling"
                        className="img-fluid partner-image"
                      />
                    </a>
                  </div>
                  <div className="col-6 col-md-3 partner-logo">
                    <a href="https://pinnaclepsychology.com/" target="_blank" rel="noopener noreferrer">
                      <img
                        src="https://brightervisionclients.com/resize/66a7caa33a23ea39af765e7c/attachments/45e432d3-3229-4f33-9bdf-de78c3f7641e"
                        alt="Pinnacle Psychology"
                        className="img-fluid partner-image"
                      />
                    </a>
                  </div>
                  <div className="col-6 col-md-3 partner-logo">
                    <a href="https://valleyhospital-phoenix.com/" target="_blank" rel="noopener noreferrer">
                      <img
                        src="/img/partners/brand-02.png"
                        alt="Valley Hospital"
                        className="img-fluid partner-image"
                      />
                    </a>
                  </div>
                  <div className="col-6 col-md-3 partner-logo">
                    <a href="https://coppersprings.com/" target="_blank" rel="noopener noreferrer">
                      <img
                        src="/img/partners/brand-05.png"
                        alt="Copper Springs"
                        className="img-fluid partner-image"
                      />
                    </a>
                  </div>
                </div>

                {/* Third Row */}
                <div className="row g-4 justify-content-center">
                  <div className="col-6 col-md-3 partner-logo">
                    <a href="https://cornerstonehealingcenter.com/" target="_blank" rel="noopener noreferrer">
                      <img
                        src="https://cornerstonehealingcenter.com/wp-content/uploads/cornerstone-logo-300x66-1-1-1.png"
                        alt="Cornerstone Healing Center"
                        className="img-fluid partner-image"
                      />
                    </a>
                  </div>
                  <div className="col-6 col-md-3 partner-logo">
                    <a href="https://rubensteincounseling.services/" target="_blank" rel="noopener noreferrer">
                      <img
                        src="/img/partners/brand-03.webp"
                        alt="Rubenstein Counseling"
                        className="img-fluid partner-image"
                      />
                    </a>
                  </div>
                  <div className="col-6 col-md-3 partner-logo">
                    <a href="https://www.charliehealth.com/" target="_blank" rel="noopener noreferrer">
                      <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRt6A2bYbnPtsM8c3ZsfMA0RmgIqgF9pA-A6g&s"
                        alt="Charlie Health"
                        className="img-fluid partner-image"
                      />
                    </a>
                  </div>
                  <div className="col-6 col-md-3 partner-logo">
                    <a href="https://www.psychologytoday.com" target="_blank" rel="noopener noreferrer" aria-label="Visit our Psychology Today profile">
                      <img
                        src="/img/partners/psychtoday.png"
                        alt="Verified by Psychology Today"
                        className="img-fluid partner-image"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {/* Widgets */}
            <Widgets />
          </div>
          <div className="push"></div>
        </motion.div >

        {/* Footer */}
        < Footer />
      </div >
    </>
  );
};

export default About;
